import { isDefined, Quaternion, Vector3 } from '@trimble-gcs/common';

export interface StationTransform {
  quaternion?: Quaternion;
  translation?: Vector3;
  scale?: Vector3;
}

export function getStationTransformHeading(
  stationTransform: StationTransform | undefined,
  headingOffsetDegrees: number,
): StationTransform {
  if (headingOffsetDegrees >= 360) {
    headingOffsetDegrees = headingOffsetDegrees % 360;
  } else if (headingOffsetDegrees < 0) {
    headingOffsetDegrees = 360 + (headingOffsetDegrees % 360);
  }

  const headingOffsetRadians = Math.round(headingOffsetDegrees) * (Math.PI / 180);
  const quaternion = Quaternion.fromEuler(0, 0, headingOffsetRadians);

  return {
    ...stationTransform,
    quaternion,
  };
}

export function calculateStationHeadingOffset(stationTransform?: StationTransform): number {
  const headingOffset = isDefined(stationTransform?.quaternion)
    ? Math.round((Quaternion.toEuler(stationTransform.quaternion).z * 180) / Math.PI)
    : 0;

  return (headingOffset < 0 ? 360 + headingOffset : headingOffset) % 360;
}
